// Check if user has already interacted with the cookie banner in this session
function checkCookieBanner() {
  const cookieBanner = document.getElementById('cookies-banner');
  if (!cookieBanner) return;
  
  // Check sessionStorage instead of localStorage for per-session storage
  const cookieConsent = sessionStorage.getItem('cookieConsent');
  
  if (cookieConsent) {
    // User has already made a choice in this session
    cookieBanner.style.display = 'none';
  } else {
    // Show the banner
    cookieBanner.style.display = 'flex';
  }
}

function handleAccept() {
  // Store the user's choice in sessionStorage (cleared when browser/tab closes)
  sessionStorage.setItem('cookieConsent', 'accepted');
  
  // Hide the banner
  const cookieBanner = document.getElementById('cookies-banner');
  if (cookieBanner) {
    cookieBanner.style.display = 'none';
  }
  
  // Add your cookie acceptance logic here
  console.log('Cookies accepted');
}

function handleDecline() {
  // Store the user's choice in sessionStorage (cleared when browser/tab closes)
  sessionStorage.setItem('cookieConsent', 'declined');
  
  // Hide the banner
  const cookieBanner = document.getElementById('cookies-banner');
  if (cookieBanner) {
    cookieBanner.style.display = 'none';
  }
  
  // Add your cookie decline logic here
  console.log('Cookies declined');
}

// Run on page load
document.addEventListener('DOMContentLoaded', checkCookieBanner);